export const SEND_CONTACT_DETAILS = "SEND_CONTACT_DETAILS";
export const SEND_CONTACT_DETAILS_SUCCESS = "SEND_CONTACT_DETAILS_SUCCESS";
export const SEND_CONTACT_DETAILS_FAILURE = "SEND_CONTACT_DETAILS_FAILURE";

export const SET_CONTACT_LOADING = "SET_CONTACT_LOADING";
export const RESET_MESSAGE = "RESET_MESSAGE";
